import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/models/user.model';
import { environment } from 'src/environments/environment';
import { AccountService } from 'src/app/services/account.service';
import { SidenavService } from '../services/sidenav.service';
import { HudComponent } from '../hud/hud.component';
import { NgClass, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css'],
    imports: [HudComponent, FormsModule, ReactiveFormsModule, NgClass, NgStyle, RouterLink]
})
export class RegisterComponent {

  private formBuilder = inject(FormBuilder);
  private http = inject(HttpClient);
  private accountService = inject(AccountService);
  private sidenavService = inject(SidenavService);

  public RegisterForm: FormGroup;
  private firstName: FormControl;
  private lastName: FormControl;
  private username: FormControl;
  private password: FormControl;
  private email: FormControl;
  submitted = false;
  loading = false;
  thermsCondition = false;
  FormMessage : string;
  f;

  constructor() {
    this.firstName = new FormControl('');
    this.lastName = new FormControl('');
    this.username = new FormControl('', [Validators.required]);
    this.password = new FormControl('', [Validators.required, Validators.minLength(6)]);
    this.email = new FormControl('', [Validators.required, Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9._%+-]{2,}[.][A-Za-z]{2,}$')]);

    this.RegisterForm = this.formBuilder.group({
      firstName: this.firstName,
      lastName: this.lastName,
      username: this.username,
      password: this.password,
      email: this.email
    })
    this.f = this.RegisterForm.controls;
  }

  canCreateAccount(): boolean {
    return true;
  }

  onSubmit() {
    this.submitted = true;
    if (this.RegisterForm.invalid) {
      return;
    }
    if (!this.thermsCondition) {
      this.FormMessage = "You must accept terms and conditions to proceed";
      return;
    }
    this.createUser(this.RegisterForm.value.username, this.RegisterForm.value.email, this.RegisterForm.value.password, this.RegisterForm.value.firstName, this.RegisterForm.value.lastName);
  }

  AcceptTermsAndCondition(arg) {
    this.thermsCondition = arg.target.checked;
  }

  createUser(User: string, Email: string, Pass: string, firstName: string, lastName: string) {
    const body = {
      "username": User,
      "email": Email,
      "password": Pass,
      "firstName": firstName,
      "lastName": lastName
    };
    this.http.post<any>( environment.apiURL + '/services/create-user', body, { observe: 'response', withCredentials: true })
      .subscribe(
        (response) => {
          this.loading = false;
          this.accountService.setUser(response.body as User);
          this.accountService.setIsLogin(true);
          this.FormMessage = "Account created and logged in";
          this.sidenavService.toggle();
        },
        (error) => {
          this.loading = false;
          switch (error.status) {
            case 0:
              this.FormMessage = "Unable to connect";
              break;
            case 400:
              this.FormMessage = "BAD_REQUEST contact admin";
              break;
            case 403:
              this.FormMessage = "You can't create an account contact admin";
              break;
            case 409:
              this.FormMessage = "CONFLICT contact admin";
              break;
            case 429:
              this.FormMessage = "Too Many Requests";
              break;
          }
        }
      );
  }
}
